
import Vue, { PropType } from "vue";
import KFieldGroup from "@/components/crud/fields/KFieldGroup.vue";
import KTextField from "@/components/crud/fields/KTextField.vue";
import PurchaseOrderStatusAutocomplete from "@/modules/delivery/components/PurchaseOrderStatusAutocomplete.vue";
import { mapGetters } from "vuex";

type ComponentData = {
  internalFilters: Record<string, any>;
};

export default Vue.extend({
  name: "ProductFilter",
  components: {
    PurchaseOrderStatusAutocomplete,
    KTextField,
    KFieldGroup,
  },
  props: {
    filters: {
      type: Object as PropType<Record<string, any>>,
      required: true,
    },
  },
  data: (): ComponentData => ({
    internalFilters: {
      plannedDateFrom: undefined,
      plannedDateTo: undefined,
      purchaseOrderStatusId: undefined,
    },
  }),
  computed: {
    ...mapGetters("authorisation", ["client"]),
  },
  watch: {
    filters: {
      handler(newFilters) {
        this.internalFilters = newFilters;
      },
      immediate: true,
      deep: true,
    },
    internalFilters: {
      handler(newFilters) {
        this.$emit("update:filters", newFilters);
      },
    },
  },
});
